module.exports = __webpack_public_path__ + "img/marker-icon-sub.d09cc6f8.svg";